import { Injectable } from '@angular/core';
import { SiriusDataService, SiriusNavigationService, SiriusResourceService, SiriusServiceBase, SiriusSessionService } from '@ibtech/sirius-angular-service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ControlAppModel, DocumentViewModelList, EFTBankListModel, LogoutModel, ReturnLoginModel, SharedModel, UIModel } from '../models/shared.model';
import { ProcessAction, ProcessDetail } from '../models/process.model';

@Injectable()
export class CommonService extends SiriusServiceBase {
  navigationService: SiriusNavigationService;
  dataService: SiriusDataService;
  sessionService: SiriusSessionService;
  shareDataSubject = new Subject<any>();
  isLoggedin = new BehaviorSubject<boolean>(null);
  notAtLoginPage = new Subject<any>();
  loggedUserName = new Subject<any>();

  private _eftBankList: EFTBankListModel | undefined;
  private _docList: DocumentViewModelList | undefined;

  get publicEftList() {
    return this._eftBankList;
  }

  get loggedinStatus() {
    return this.isLoggedin.getValue();
  }

  public get publicDocList() {
    return this._docList;
  }
  public set publicDocList(docList: DocumentViewModelList) {
    this._docList = docList;
  } 
 

    public setEftBankList(dataService: SiriusDataService) {
        //this.showLoadingAnimate.next(false);
      let promise = dataService.get("GetEftBankListFromStaticData");
        promise.toPromise().then((result) => {
            //this.showLoadingAnimate.next(true);
            this._eftBankList = <EFTBankListModel>result; 
        });
    }

    public getDocumentList() {
      let model = new DocumentViewModelList();
      let promise = this.dataService.post<DocumentViewModelList>("GetDocumentList", model).toPromise();
        promise.then((result) => {
            this._docList = <DocumentViewModelList>result;
        });
    }

  constructor(private router: Router,
    private resourceService: SiriusResourceService,
    private locationService: Location) {
    super();
    }

   
    isMobileView() {
        if (window.innerWidth <= 768) {
            return true;
        }
        return false;
    }

    updPhnrTnPk() {
        let model = new ControlAppModel();
        model.App = 'UpdPhnrTnPk';
        var promise = this.dataService.post<ControlAppModel>("UpdPhnrTnPk", model);
      
        return promise;
        
    } 

    isLv() {
        let model = new UIModel(); 
        var promise = this.dataService.post<UIModel>("LoadPage", model); 
        return promise; 
    } 


    changeHeaderImage(path: string) {
        this.shareDataSubject.next(path);
    }


    redirect() {
        this.navigationService.goToRoute(SharedModel.Login);
        
    }


    StartTransaction(transactionName: string, pageName: string = SharedModel.PageName_Login) {
        this.navigationService.startTransactionWithOptions({ transactionName: transactionName, redirect: true });
    } 

    logOut(isFromLogin: boolean) {
      var promise = this.dataService.post<LogoutModel>("LogOut", null);
      promise.toPromise().then((result) => {
            
        });
        this.sessionService.forceTimeout = true;
        this.sessionService.authenticated = false;
        this.isLoggedin.next(false);
        this.loggedUserName.next('');
        if (!isFromLogin)
            this.navigationService.goToRouteUrl(SharedModel.PageName_Landing);
    }

    logOutClient() {
        this.sessionService.forceTimeout = true;
        this.sessionService.authenticated = false;
        this.isLoggedin.next(false);
        this.loggedUserName.next(''); 
        this.navigationService.startTransactionWithOptions({ transactionName: "LoginFormTransaction", redirect: true }); 
    }

    logOutClientNoRoute() {
        this.sessionService.forceTimeout = true;
        this.sessionService.authenticated = false;
        this.isLoggedin.next(false);
        this.loggedUserName.next(''); 
    }

    logOutAtLogin() {
      var promise = this.dataService.post<LogoutModel>("LogOut", null);
      promise.toPromise().then((result) => {

        });
        this.sessionService.forceTimeout = true;
        this.sessionService.authenticated = false;
        this.isLoggedin.next(false);
        this.loggedUserName.next('');
        this.navigationService.startTransactionWithOptions({ transactionName: "LoginFormTransaction", redirect: true });
    }

    getGeneralErrorMessage() { 
        return this.resourceService.getResource(SharedModel.NotContinueByYourInput);
    }

    urlService() {
        setTimeout(() => {
            var ind = this.locationService.path().lastIndexOf("/");
            var url = this.locationService.path();
            var urlLen = this.locationService.path().length;
            var repUrl = url.substring(0, ind);
            this.locationService.replaceState(repUrl);
        }, 1);
    } 
  

    startCaptchaValidation(dataService: SiriusDataService, model: any) {
      var promise = dataService.post<ReturnLoginModel>("StartCaptchaValidation", model);
      return promise.toPromise();
    }

    applyLogin(dataService: SiriusDataService, model: any) {
      var promise = dataService.post<ReturnLoginModel>("ApplyLogin", model);
      return promise.toPromise();
    }

    applyLoginWs(dataService: SiriusDataService, model: any) {
        var promise = dataService.post<ReturnLoginModel>("ValidateSms", model);
      return promise.toPromise();
    }

    recordNewMember(dataService: SiriusDataService, model: any) {
        var promise = dataService.post<ReturnLoginModel>("RecordNewMember", model);
        return promise;
    }

    actMemberControl(dataService: SiriusDataService, model: any) {
        var promise = dataService.post<ReturnLoginModel>("ActMemberControl", model);
      return promise.toPromise();
    }

    validateCaptcha(dataService: SiriusDataService, model: any) {
        var promise = dataService.post<ReturnLoginModel>("ValidateCaptcha", model);
        return promise;
    }
      
    loadPage(dataService: SiriusDataService) {
        var promise = dataService.post<UIModel>("LoadPage", null);
      return promise.toPromise();
    }   


    static isNullOrEmpty(input: string) {
        return (input == null || input == "");
    }

    prepareStringText(text: string, parameters: { key: string, value: string, bold?: boolean }[]): string {
        parameters.forEach((parameter) => {
            if (parameter.bold != null && parameter.bold) {
                text = text.split("[" + parameter.key + "]").join("<b>[" + parameter.key + "]</b>");
                text = text.split("[" + parameter.key + "]").join(parameter.value);
            }
            else {
                text = text.split("[" + parameter.key + "]").join(parameter.value);
            }            
        });
        return text;
    }

    selectedProcessDetail: { processRef: string, data: ProcessDetail } = null;
    GetProcessDetail(dataService: SiriusDataService, processDetailActionRequest: any) {
      return dataService.post("GetProcessDetail", processDetailActionRequest).toPromise();
    }

    selectedProcessAction: { processRef: string, data: ProcessAction } = null;
    GetProcessAction(dataService: SiriusDataService, processDetailActionRequest: any) {
      return dataService.post("GetProcessAction", processDetailActionRequest).toPromise();
    }

    CancelProcess(dataService: SiriusDataService, cancelProcessInfo: any) {
      return dataService.post("CancelProcess", cancelProcessInfo).toPromise();
    }  

    GetUserOwnAccounts(dataService: SiriusDataService) {
      return dataService.post("GetAccList", null).toPromise();
  }
  getKvvkTitle() {
    return this.resourceService.getResource(SharedModel.KvkkTitle);
  }
}
